import { useLocation } from 'react-router-dom';

// DEPRECATED: in favor of Hooks/useUrlQuery
export const useQuery = () => new URLSearchParams(useLocation().search);
